import Environment from "../environments/base.environment";

//exporting keys based on Environment.
export const KEYS = Environment.ENVIROMENT_KEYS();

// Splash Screen properties
export const splashShowDuration = 3500;
export const splashImage = "wizard/assets/images/splash.gif";

export const MOBILE_NUMBER_LENGTH = 10;

export enum CountryWiseCodes {
  USA = '+1',
  CANADA = '+1',
  MEXICO = '+52'
}

export const CountryCodes =  [
  {"US": "+1"},
  {"MX": "+52"}
];

export enum FALLBACK_URLS {
  DEFAULT_REDIRECT_URL = "https://freightpower.schneider.com/carrier",
  FREIGHTPOWER_TERMS_OF_USE = "https://schneider.com/freightpower-terms-of-use",
  PRIVACY_POLICY = "https://schneider.com/privacy-policy/freight-power",
  EMAIL = "mailto:FreightPowerCarrier@schneider.com",
}

export enum SERVER_ERROR_MESSAGES {
  serverErrorMsg = "Error, please refresh and try again",
  unAuthorizedMsg = "Login expired, Log Out and log back in to try again",
  fpsInvalidMsg = "quoteInvalidTransportModeError",
}

export enum SORT_OPTIONS {
  pickUpStartDate = "pickUpStartDate",
  total_distance = "total_distance",
  price = "price",
  originDeadHead = "originDeadHead",
  destinationDeadHead = "destinationDeadHead",
}

export const CONTENT_OR_CONFIG_TABLE_MAPPING = {
  Global: {
    tableName: "USERLESS_WIZARD_CONFIG",
    REDIRECT_FALLBACK_URL: "REDIRECT_FALLBACK_URL",
    QUOTE_LOGO_URL: "QUOTE_LOGO_URL",
    source: "SNIConfig",
    banner: "fpw_alert_banner",
    FOOTER_CONTENT_TYPE: "fpw_elements",
  
    WIZARD_GLOBAL_REDIRECT_URL: "WIZARD_GLOBAL_REDIRECT_URL"
  },
};

export enum OOPS_NO_RECORD_FOUND_MESSAGE {
  OOPS_TITLE = "Error",
  OOPS_MESSAGE = "Requested record not found. <br />Click ok to go back",
  PAGE_NOT_FOUND_MESSAGE1 = "Oops!",
  PAGE_NOT_FOUND_MESSAGE2 = "Page not Found.",
  PAGE_NOT_FOUND_MESSAGE3 = "We couldn't find the page",
  PAGE_NOT_FOUND_MESSAGE4 = "Click ok to go back or click Homepage to go back to Home screen",
  BACK_BTN = "Go Back",
  HOME_BTN = "Home Page",
}
export enum ICON_PATH {
  pageNotFound = "wizard/assets/icons/pageNotFound.svg",
}

export const trailersConfiguration: {
  [key: string]: {
    width?: string;
    webWidth?: string;
    showReadOnlyField?: boolean;
    placeholder: string;
    maxlength: any;
    keyBoardType?: any;
    type?: any;
    totalWidth?: string;
    mobileWidth?: string;
  };
} = {
  TA: {
    width: "20px",
    webWidth: "70px",
    showReadOnlyField: true,
    placeholder: "######",
    maxlength: 6,
    keyBoardType: "numeric",
    type: "number",
    totalWidth: "320px",
    mobileWidth: "230px",
  },
  SNLU: {
    width: "40px",
    webWidth: "70px",
    showReadOnlyField: true,
    placeholder: "######",
    maxlength: 6,
    keyBoardType: "numeric",
    type: "number",
    totalWidth: "300px",
    mobileWidth: "210px",
  },
  OTHER: {
    placeholder: "@#@#@#@#@#@#@#@",
    showReadOnlyField: false,
    maxlength: 15,
    keyBoardType: "text",
    type: "text",
    totalWidth: "340px",
    mobileWidth: "250px",
  },
  BOBTAIL: {
    placeholder: "",
    showReadOnlyField: false,
    maxlength: 0,
    keyBoardType: "text",
    type: "text",
    totalWidth: "340px",
    mobileWidth: "250px",
  },
};

export const BOBTAIL = "BOBTAIL";

export const OTHER = "OTHER";
export const TA = "TA";
export const SNLU = "SNLU";

export const dropDownOptions = ["TA", "SNLU", "BOBTAIL", "OTHER"];

export enum EAtType {
  YesOrNo = "YesOrNoActivity",
  End = "EndActivity",
  Calendar = "CalendarActivity",
  TrailerDropDown = "TrailerDropdownActivity",
  DriverDetails = "DriverAssignActivity",
  Error = "ErrorActivity",
  SingleSelectOptionActivity = "SingleSelectOptionActivity",
  SingleQuestionActivity = "SingleQuestionActivity",
  MultipleQuestionActivity = "MultipleQuestionActivity",
  CommodityActivity = "CommodityActivity",
  FormSubmitActivity = "FormSubmitActivity",
  EndActivity = "EndActivity",
  DispatcherDetailsActivity ="DispatcherDetailsActivity",
}
export enum EActionType {
  Continue = "Continue",
  Request_Quote = "Request Quote"
}

export enum EAccessMode {
  mobileAccess = "Mobile",
  webAccess = "Web",
}

export enum EReferredActivity {
  RetrieveActivity = "retrieveActivity",
  PublishGeoLocationAction = "publishGeoLocationAction",
  TrailerDropDownActivity = "trailerUpdateAction",
  TrailerOutActivityId = "outboundTrailerUpdate_Yes",
  TrailerOutActivityIdforAction = "outboundTrailerUpdate",
  TrailerOutActivity = "TRAILER_OUT",
  TrailerInActivity = "TRAILER_IN",
}

export enum QuestionLabel {
  stopArrivalQuestion = "When did you arrive?",
  trailerTypeQuestion = "What was the trailer#?",
}
export enum DRIVER_PROFILE_FIELDS {
  FIRST_NAME = "First Name",
  LAST_NAME = "Last Name",
  MOBILE_NUMBER = "Mobile Number",
  EMAIL = "Email (Optional)",
  START_LOCATION = "Start Location ",
  TRUCK_NUMBER = "Truck Number",
  START_DATETIME = "Start Date and Time",
  INFO = "Confirm or change the Start Location information",
}
export enum DISPATCHER_PROFILE_FIELDS {
  EMAIL = "Email"
}
export enum FORMFIELDS {
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  MOBILE_NUMBER = "mobileNumber",
  EMAIL = "email",
  COMMODITYWEIGHT = "totalCommoditiesWeight(Lbs)"

}
export enum PLACEHOLDERVALUE {
  FIRST_NAME = "Enter first name",
  LAST_NAME = "Enter last name",
  MOBILE_NUMBER = "Enter mobile number",
  EMAIL = "Enter email address",
  COMMODITYWEIGHT = "Type Commodities Weight"

}
export enum DRIVER_PROFILE_FIELDS_VALUE {
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  MOBILE_COUNTRY_CODE = "mobileCountryCode",
  MOBILE_NUMBER = "mobileNumber",
  EMAIL = "email",
  START_LOCATION = "startLocation",
  TRUCK_NUMBER = "truckNumber",
}
export enum DRIVER_DETAILS_FORM {
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  MOBILE_COUNTRY_CODE = "mobileCountryCode",
  MOBILE_NUMBER = "mobileNumber",
  EMAIL = "email",
  START_LOCATION = "startLocation",
  TRUCK_NUMBER = "truckNumber",
  START_DATETIME = "startDateTime",
  TOTAL_COMMODITIES_WEIGHT = "Total Commodities Weight12",
}

export const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const enableGPSmessage = "Please Turn Location Services and GPS on.";

export enum ACTIVITY_IDS {
  PING_LOCATION = "pingLocation",
  STOP_ARRIVAL_UPDATE = "stopArrivalUpdate",
  STOP_ARRIVAL_ETA = "stopArrivalUpdate_Yes",
  TRAILER_IN = "inboundTrailerUpdate",
  STOP_DEPARTURE_UPDATE = "stopDepartureUpdate",
  STOP_DEPARTURE_ETA = "stopDepartureUpdate_Yes",
  TRAILER_OUT = "outboundTrailerUpdate",
  TRAILER_OUT_UPDATE = "outboundTrailerUpdate_Yes",
  END_ACTIVITY = "endActivity",
  ASSIGN_DRIVER = "assignDriver",
  DISPATCHERDETAILS= "dispatcherDetails",
  ASSIGNDRIVER_YES = "assignDriver_Yes",
  ACCEPTSHIPMENT ="acceptShipment",
  DETERMINESTOPACTIVITY="determineStopActivity",
  SCDMENDACTIVITY ="scdmEndActivity",
  QUOTETRANSPORTMODE = "quoteTransportMode",
  QUOTEPICKUP = "quotePickup",
  QUOTEDELIVERY = "quoteDelivery",
  REQUESTQUOTE = "requestQuote",
  QUOTEQUOTEDENDACTIVITY="quoteQuotedEndActivity",
  QUOTELOGINENDACTIVITY="quoteLoginEndActivity",
  QUOTEEXCEEDENDACTIVITY="quoteExceedEndActivity",
  RESTRICTED="quoteRestrictedEndActivity",
  COMMODITY="commodity"
}


export const MOBILE_NUMBER_ERROR_RESPONSE_MESSAGE =
  "Invalid Number / Country code is not matching";
export const MOBILE_NUMBER_VALIDATION_MESSAGE =
  "Please enter a valid Mobile Number";
export const MOBILE_NUMBER_DIGIT_MESSAGE =
  "Mobile Number should contain 10 digits";
export const MOBILE_NUMBER_REQUIRED_MESSAGE = "Mobile Number is required";
export const START_LOCATION_DIGIT_MESSAGE =
  "Start Location should contain atleast 3 letters";
export const START_LOCATION_REQUIRED_MESSAGE = "Start Location is required";
export const PICKUP_LOCATION_PLACEHOLDER = "Type City or Postal Code";
export const EMAIL_VALIDATION_MESSAGE = "Please enter a valid Email Address";
export const LTL = "ltl";
export const LESS_THAN_TRUCKLOAD ="Less Than Truckload";
export const LTL_COMMODITY_INPUT_MAXLENGTH = 6;
export const LOGINLINK = "https://schneiderfreightpowercarrier.page.link/sejC";
export const REGISTERLINK = "https://schneiderfreightpowercarrier.page.link/ndEu";
export const REGISTERCARRIEROFFLINE = [
  {
     image: `${process.env.PUBLIC_URL}/assets/images/Rectangle1966.svg`,
     registerCarrierData: "Book a Load",
     webLink: "https://schneiderfreightpowercarrier.page.link/86To",
     imageURL: `${process.env.PUBLIC_URL}/assets/images/Book.svg`
  },
  {
     image: `${process.env.PUBLIC_URL}/assets/images/Rectangle1966.svg`,
     registerCarrierData: "Purchasing Program",
     webLink: "https://schneiderfreightpowercarrier.page.link/Gvs4",
     imageURL: `${process.env.PUBLIC_URL}/assets/images/Purchase.svg`

  },
  {
     image: `${process.env.PUBLIC_URL}/assets/images/Rectangle1966.svg`,
     registerCarrierData: "Load Recommendations",
     webLink: "https://schneiderfreightpowercarrier.page.link/JzCQ",
     imageURL: `${process.env.PUBLIC_URL}/assets/images/recom.svg`
  }
];